export const API_PATH_apiUserInvitationsTemplateDefaultPost = '/services/users-invitations/template-default';
